import { useTransactionStore } from "../../stores/transactionStore";
import { Toast } from "./Toast";

export function ToastContainer() {
	const toasts = useTransactionStore((s) => s.toasts);
	const removeToast = useTransactionStore((s) => s.removeToast);

	if (toasts.length === 0) return null;

	return (
		<div className="toast-container">
			{toasts.map((toast) => (
				<Toast key={toast.id} toast={toast} onDismiss={removeToast} />
			))}
		</div>
	);
}
